export enum DecisionMenuItemsIdsEnum {
  KNM_INFO = 'KNM_INFO',
  KNM_VERIFIED_PERSON = 'KNM_VERIFIED_PERSON',
  KNM_OBJECTS_INFO = 'KNM_OBJECTS_INFO',
  DECISION_VIOLATIONS = 'DECISION_VIOLATIONS',
  DECISION_EVENTS = 'DECISION_EVENTS',
  DECISION_RESULT = 'DECISION_RESULT',
  KNM_DOCUMENTS = 'KNM_DOCUMENTS',
  DECISION_ACT = 'DECISION_ACT',
  DECISION_INFO = 'DECISION_INFO',
  KNM_SIGN_INFO = 'KNM_SIGN_INFO',
  KNM_EPGU_NOTIFICATION = 'KNM_EPGU_NOTIFICATION',
  DECISION_COMPLAINT = 'DECISION_COMPLAINT',
  KNM_JUDGMENTS = 'KNM_JUDGMENTS',
  KNM_HISTORY = 'KNM_HISTORY',
  AGREEMENTS = 'AGREEMENTS',
  REPEAT_PASSPORTS = 'REPEAT_PASSPORTS',
}
